<template>
  <div class="mk-banner">
    <div class="top-banner">
      <ul class="banner-list" @touchstart="handleTouchStart($event)" @touchmove="handleTouchMove($event)">
        <li v-for="(banner, bannerIndex) in bannerListData" :key="bannerIndex"
            :class="{'banner': true,
                     'center': blockOffsetArr[bannerIndex]===0,
                     'side': Math.abs(blockOffsetArr[bannerIndex])===blockWidth}"
            :style="{'transform': 'translate3d(' + blockOffsetArr[bannerIndex] + 'px, 0px, 0px)',
                     'opacity': (Math.abs(blockOffsetArr[bannerIndex]) > blockWidth*2) ? 0 : 1,
                     'visibility': (Math.abs(blockOffsetArr[bannerIndex]) > blockWidth*2) ? 'hidden' : 'visible'}"
        >
          <a :aria-label="banner.label" href="#" class="banner-block" rel="noopener noreferrer"
             @click="handleBannerClick(banner.url, banner.label)"
          >
            <img :src="fileHost+banner.img" :alt="banner.label">
          </a>
        </li>
      </ul>
      <a href="#" class="btn-arrow btn-prev" @click.prevent="goPrev(false)">
        <i class="material-icons">
          chevron_left
        </i>
      </a>
      <a href="#" class="btn-arrow btn-next" @click.prevent="goNext(false)">
        <i class="material-icons">
          chevron_right
        </i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselBanner',
  components: {},
  props: {
    gaAction: {
      type: String,
      default: ''
    },
    bannerOrinData: {
      type: Array,
      default: () => []
    },
    bannerDuration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      fileHost: process.env.VUE_APP_FILE_HOST,
      bannerListData: [],
      blockWidth: 0,
      blockWidthOffset: 0,
      blockOffsetArr: [],
      interval: ''
    }
  },
  computed: {},
  watch: {
    bannerOrinData(newVal) {
      this.bannerInit()
    }
  },
  created() {},
  mounted() {
    window.addEventListener('resize', this.bannerInit)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.bannerInit)
  },
  updated() {},
  methods: {
    bannerInit() {
      this.bannerListData = []
      this.blockOffsetArr = []
      this.bannerListData = this.bannerListData.concat(this.bannerOrinData).concat(this.bannerOrinData).concat(this.bannerOrinData)
      this.blockWidth = document.querySelector('.banner-list').offsetWidth
      this.blockWidthOffset = this.blockWidth
      this.bannerListData.forEach((list, index) => {
        this.blockOffsetArr[index] = this.blockWidth * index - (this.blockWidthOffset * 4)
      })
      this.bannerAnimation()
    },
    bannerAnimation() {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.goNext()
      }, this.bannerDuration)
    },
    isClearInterval(isAuto) {
      if ((isAuto !== undefined) && !isAuto) {
        this.bannerAnimation()
      }
    },
    goNext(isAuto) {
      const lastEle = this.blockOffsetArr.pop()
      this.blockOffsetArr.unshift(lastEle)
      this.isClearInterval(isAuto)
    },
    goPrev(isAuto) {
      const firstEle = this.blockOffsetArr.shift()
      this.blockOffsetArr.push(firstEle)
      this.isClearInterval(isAuto)
    },
    handleTouchStart(event) {
      const touch = event.touches
      this.xDown = touch[0].clientX
      this.yDown = touch[0].clientY
    },
    handleTouchMove(event) {
      if (!this.xDown || !this.yDown) {
        return
      }
      let xUp = event.touches[0].clientX
      let yUp = event.touches[0].clientY
      let xDiff = this.xDown - xUp
      let yDiff = this.yDown - yUp
      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) { // left
          this.goNext()
        } else { // right
          this.goPrev()
        }
      } else {
        if (yDiff > 0) { // up
        } else { // down
        }
      }
      // reset
      this.xDown = null
      this.yDown = null
    },
    handleBannerClick(targetUrl, targetLabel) {
      // GTAG Event
      this.$store.dispatch('GTAG_EVENT', {
        action: this.gaAction,
        data: {
          event_category: 'topBanner',
          event_label: targetLabel + ' ' + targetUrl
        }
      })
      if (targetUrl) {
        window.open(targetUrl, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.mk-banner{
  width: 100%;
  max-width: 2283px;
  margin: auto;
  overflow: hidden;
}

.top-banner{
  position: relative;
  max-width: 761px;
  width: 100%;
  margin: auto;
  overflow: visible;
  .btn-arrow{
    position: absolute;
    opacity: 0;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #fff;
    top: 0;
    bottom: 0;
    left: -44px;
    margin: auto;
    z-index: 1;
    text-align: center;
    line-height: 45px;
    border: 2px solid #ececec;
    transition: .2s;
    i {
      display: inline-block;
      font-size: 36px;
      vertical-align: middle;
      color: #000;
    }
    &.btn-next{
      left: inherit;
      right: -44px;
    }
    &:hover{
      background: #F3F3F3
    }
  }
  &:hover{
    .btn-arrow{
      opacity: 1;
    }
  }
}
.banner-list{
  position: relative;
  max-width: 100%;
  height: 406px;
  margin: 0 auto;
  list-style: none;
  padding: 0;
  touch-action: pan-y;
  li{
    display: inline-block;
    position: absolute;
    top: 0;
    width: 100%;
    padding: 8px;
    transform: translate3d(0px, 0px, 0px);
    transition: transform .6s ease;
    margin: 0;
    .banner-block{
      display: block;
      position: relative;
      width: 100%;
      padding-top: 52%;
      overflow: hidden;
    }
    img{
      display: inline-block;
      position: absolute;
      width: 100%;
      height: auto;
      top: 0;
      left: 0;
    }
    &.center,
    &.side{
      &:before{
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.8);
        z-index: 1;
        transition: .8s;
        pointer-events: none;
      }
    }
    &.center{
      &:before{
        // z-index: 0;
        background: rgba(255, 255, 255, 0);
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .top-banner{
    max-width: 616px;
    .btn-arrow{
      left: -20px;
      &.btn-next{
        right: -20px;
      }
    }
  }
  .banner-list{
    height: 314px;
  }
}
@media only screen and (max-width: 767.98px) {
  .top-banner{
    max-width: 78%;
    min-width: 280px;
    .btn-arrow{
      width: 32px;
      height: 32px;
      line-height: 25px;
      left: -14px;
      i {
        font-size: 24px;
      }
      &.btn-next{
        right: -12px;
      }
    }
  }
  .banner-list{
    padding-top: 52%;
    height: auto;
    min-height: 143px;
    li {
      padding: 4px;
    }
  }
}
</style>
